import { mutatorAction } from 'satcheljs';
import type ItemPartViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState';

export const expandCollapseFossilizedTextMutator = mutatorAction(
    'expandCollapseFossilizedTextMutator',
    (itemPart: ItemPartViewState, shouldExpand: boolean) => {
        itemPart.isFossilizedTextExpanded = shouldExpand;
    }
);
